import React from 'react';
import PageLayout from '../../components/Layout/PageLayout';

const SpecifyConstraints = props => {
  return <PageLayout>{props.location.pathname}</PageLayout>;
};

export default SpecifyConstraints;
